import { generateRequest } from './index';

export const Action = {
  Contests: {
    EnterContestPending: 'EnterContest_PENDING',
    EnterContestCompleted: 'EnterContest_FULFILLED',
    EnterContestFailed: 'EnterContest_FAILED',
    FetchCurrentContestPending: 'FetchCurrentContest_PENDING',
    FetchCurrentContestCompleted: 'FetchCurrentContest_FULFILLED',
    FetchCurrentContestFailed: 'FetchCurrentContest_FAILED',
    FetchRecentWinnersPending: 'FetchRecentWinners_PENDING',
    FetchRecentWinnersCompleted: 'FetchRecentWinners_FULFILLED',
    FetchRecentWinnersFailed: 'FetchRecentWinners_FAILED',
  },
};

export const createEntry = body => generateRequest({
  method: 'POST',
  credentials: 'same-origin',
  endpoint: '/assets-v2/api/entries',
  body,
  types: [
    Action.Contests.EnterContestPending,
    Action.Contests.EnterContestCompleted,
    Action.Contests.EnterContestFailed,
  ],
});

export const fetchContest = () => generateRequest({
  endpoint: '/assets-v2/api/contests',
  types: [
    Action.Contests.FetchCurrentContestPending,
    Action.Contests.FetchCurrentContestCompleted,
    Action.Contests.FetchCurrentContestFailed,
  ],
});

export const fetchRecentWinner = () => generateRequest({
  endpoint: '/assets-v2/api/contests/recentWinner',
  types: [
    Action.Contests.FetchRecentWinnersPending,
    Action.Contests.FetchRecentWinnersCompleted,
    Action.Contests.FetchRecentWinnersFailed,
  ],
});
